<template>
  <ElButton
    v-if="!user.activated"
    type="info"
    @click="activateAccount"
  >
    ACTIVATE ACCOUNT
  </ElButton>
</template>

<script>
import axios from '@/axios/axios'

export default {
  name: 'ActivateAccount',
  props: {
    user: {
      type: Object,
      required: true
    },
    isRecruiter: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    activateAccount() {
      const data = {
        email: this.user.email
      }

      return axios.put('admin/user/activate', data)
        .then(res => {
          this.$store.commit('activateUserAccount', {
            id: this.user.id,
            isRecruiter: this.isRecruiter
          })

          this.successNotification('Account has been activated!')
        })
        .catch(axios.handleError)
    }
  }
}
</script>
